// Explore-stats page: Parliamentary party statistics.
// Recreates the Handbook page — a Gantt timeline of every party's span in
// Parliament (colour = party), with a first/last-Parliament table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import GanttTimeline from './GanttTimeline';

export default function ParliamentaryPartyStatistics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('parliamentary-party-statistics');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Parliamentary party statistics"
      description={`A timeline of parliamentary parties over time${
        charts.total ? ` (${charts.total} parties)` : ''
      } — the rise and fall of parties, those present since Federation (Labor, Independents), and the many short-lived ones.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="parliamentary-party-statistics"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Parties in Parliament over time
          </Typography>
          <GanttTimeline items={charts.timeline || []} rowHeight={18} />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
